import { CloseButtonSVG, CloseButtonWrapper } from './styled';

type Props = {
  readonly onClick: () => void;
};

export const CloseButton = ({ onClick }: Props) => {
  return (
    <CloseButtonWrapper
      onClick={(event) => {
        event.preventDefault();
        onClick();
      }}
    >
      <CloseButtonSVG />
    </CloseButtonWrapper>
  );
};
